export default __webpack_public_path__ + "static/media/partner3.011a6a87.jpg";